import HippoLoading from '../../../assets/illustration/hippo-loading.png';
import HippoMain from '../../../assets/illustration/hippo-main.png';
import HippoStart from '../../../assets/illustration/hippo-start.png';
import HippoWithRoad from '../../../assets/illustration/hippo-with-road.png';
import UserAvatarBorder from '../../../assets/illustration/avatar-border.png';
import CompetitionMode from '../../../assets/illustration/competition-mode-bg.png';
import GeneralMode from '../../../assets/illustration/general-mode-bg.png';
import HippoSuccess from '../../../assets/illustration/hippo-success.png';
import QuestsBanner from '../../../assets/illustration/quests-banner.png';
import GameResultModal from '../../../assets/illustration/game-result-modal-bg.png';
import StreetViewMock from '../../../assets/illustration/street-view-mock.jpg';
import InviteFriendsBanner from '../../../assets/illustration/invite-friends-banner.png';
import ReferralsBanner from '../../../assets/illustration/referrals-banner.png';
import HippoWithPhone from '../../../assets/illustration/hippo-with-phone.png';
import HippoWithError from '../../../assets/illustration/hippo-with-error.png';
import HippoColoredSuccess from '../../../assets/illustration/hippo-success-colored.png';
import TrainingMode from '../../../assets/illustration/training-mode-bg.png';
import MainBackground from '../../../assets/illustration/main-background.png';
import HippoBlack from '../../../assets/illustration/hippo-black.png';
import DesktopQuestsBanner from '../../../assets/illustration/desktop-banner-quests.png';

const Illustrations = {
  HippoLoading,
  HippoMain,
  HippoStart,
  HippoWithRoad,
  UserAvatarBorder,
  CompetitionMode,
  GeneralMode,
  HippoSuccess,
  QuestsBanner,
  GameResultModal,
  StreetViewMock,
  InviteFriendsBanner,
  ReferralsBanner,
  HippoWithPhone,
  HippoWithError,
  HippoColoredSuccess,
  TrainingMode,
  MainBackground,
  HippoBlack,
  DesktopQuestsBanner,
};

export type TIllustration = keyof typeof Illustrations;
export default Illustrations;
